import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/root-reducer';

import { buildCleaningRows } from '../domain/profile-cleaning.rules';

const selectState = (state: RootState) => state.profileCleaning;

export const selectBrokenUrlProfiles = (state: RootState) => selectState(state).brokenUrlProfiles;
export const selectDuplicateGroups = (state: RootState) => selectState(state).duplicateGroups;
export const selectMixedCurrencyProfiles = (state: RootState) =>
  selectState(state).mixedCurrencyProfiles;
/** Profiles whose Exits & investments are to complete (#754). */
export const selectToCompleteProfiles = (state: RootState) => selectState(state).toCompleteProfiles;
/** The profiles to complete could not be read (#754). */
export const selectToCompleteFailed = (state: RootState) => selectState(state).toCompleteFailed;
export const selectLoadStatus = (state: RootState) => selectState(state).loadStatus;
export const selectLastClean = (state: RootState) => selectState(state).lastClean;
export const selectLastCleanLoaded = (state: RootState) => selectState(state).lastCleanLoaded;
export const selectCleaning = (state: RootState) => selectState(state).cleaning;
export const selectMergingGroupId = (state: RootState) => selectState(state).mergingGroupId;
export const selectNotice = (state: RootState) => selectState(state).notice;
export const selectConverting = (state: RootState) => selectState(state).converting;
/** The "Profile Cleaning" sidebar badge (#753); `null` until first read. */
export const selectIssueCount = (state: RootState) => selectState(state).issueCount;
/** The "Exits & investments to complete" queue's size, for the badge's tooltip (#754); `null` until first read. */
export const selectToCompleteCount = (state: RootState) => selectState(state).toCompleteCount;

/** The profile of the open "Convert currencies" dialog, or null (#732). */
export const selectConvertProfile = createSelector(
  selectMixedCurrencyProfiles,
  (state: RootState) => selectState(state).convertProfileId,
  (profiles, id) => (id ? (profiles.find((p) => p.id === id) ?? null) : null),
);
export const selectSelectionResetToken = (state: RootState) =>
  selectState(state).selectionResetToken;

// ── Derived, memoised (pure domain rules) ──
export const selectRows = createSelector(
  selectBrokenUrlProfiles,
  selectDuplicateGroups,
  selectMixedCurrencyProfiles,
  selectToCompleteProfiles,
  buildCleaningRows,
);
